import { Alert, Box, Button } from "@mui/material";

// Shared recoverable-error block for the AA Projects surfaces (spec §5.10 P0:
// "load errors are recoverable — retry + back, never dead-ends"). A dismissible
// inline Alert carrying a Retry action, and an optional Back action for
// full-view errors where retry alone could still strand the user.
interface RetryableErrorProps {
  message: string;
  onRetry?: () => void;
  onBack?: () => void;
  testId?: string;
}

export default function RetryableError({
  message,
  onRetry,
  onBack,
  testId,
}: RetryableErrorProps) {
  return (
    <Alert
      severity="error"
      data-testid={testId}
      action={
        <Box sx={{ display: "flex", gap: 0.5 }}>
          {onBack && (
            <Button
              color="inherit"
              size="small"
              onClick={onBack}
              data-testid={testId ? `${testId}-back` : undefined}
            >
              Back
            </Button>
          )}
          {onRetry && (
            <Button
              color="inherit"
              size="small"
              onClick={onRetry}
              data-testid={testId ? `${testId}-retry` : undefined}
            >
              Retry
            </Button>
          )}
        </Box>
      }
    >
      {message}
    </Alert>
  );
}
